import { combineReducers } from 'redux';
import authReducer from './authReducer';
import rigReducer from './rigReducer';

export default combineReducers({
	authReducer,
	rigReducer
});